interface IPageInfo {
  page_name: string;
  page_url: string;
}

export interface IPdfItem {
  id: number;
  name: string;
  url: string;
}

interface IChapterInfo {
  category: string;
  id: number;
  is_content_unit: boolean;
  name: string;
  need_publish: boolean;
  parent_id: number;
  lowest_real_unit?: boolean;
  status?: '上线' | '下线';
  children?: IChapterInfo[];
}

export interface IBookInfoData {
  book_info: {
    grade: string;
    name: string;
    page_count: string;
    publisher: string;
    term: string;
    title: string;
  };
  chapter_info: IChapterInfo[];
  page_list: IPageInfo[];
  jsonurl: string;
}

export interface ITempAgentDataInfo {
  icon_url: string;
  id: number;
  name: string;
  reference_count: number;
  status: string;
  create_at: string;
  update_at: string;
  publish_at: string;
  need_publish?: boolean;
}

export const initITempAgentDataInfo: ITempAgentDataInfo = {
  icon_url: '',
  id: 0,
  name: '',
  reference_count: 0,
  status: '',
  create_at: '',
  update_at: '',
  publish_at: '',
};

const initBookInfoData: IBookInfoData = {
  book_info: {
    grade: '3年级',
    name: 'AI伴我学作文',
    page_count: '75',
    publisher: '四川教育出版社',
    term: '下学期',
    title: 'https://ra.namibox.com/tina/static/v/publisher/川教版/title.png',
  },
  chapter_info: [],
  page_list: [],
  jsonurl: '',
};

interface IChenlieItem {
  id?: number;
  text: string;
}

export interface IContentCreate {
  unitid: string;
  bookList: IBookItemInfo[];
  bookData: IBookInfoData;
  config_list: IConfigItem[];
  activeGrounp: IConfigGrounpItem | null;
  activeGrounpChild: IGrounpChildItem | null;
  activeAgentInfo: IAgentInfo; // 当前智能体详情
  activeRuanWenInfo: IActiveRuanwen;
  templateGroups: ITemplateGroupsItem[];

  // 选中的文本陈列
  activeWenbenchenlieList: IChenlieItem[];
  activeKey: string;
  isshowBindDrawer: {
    isshow: boolean;
    type: string; //'' | 'test' | 'select';
  };
  testAgent: ITempAgentDataInfo;
  shuxingChangedFlag: boolean; // 属性是否被更改
  tagList: string[];
  guanliAgentChangeFlag: boolean;
  freshFeedbackFlag: boolean;
}

interface IBookItemInfo {}

export interface IConfigGrounpItem {
  name: string;
  id: number;
  is_free: 0 | 1;
  items: IGrounpChildItem[];
}

export interface IAgentInfo {
  introduce: string; // 开场白
  model_name: string; // 类型
  img_list: string[]; // 图片
  prompt: string;
  id: number;
  name: string;
  template_id: number;
  isFromTem: boolean;
}

export interface IActiveRuanwen {
  id: number;
  title: string;
  subtitle: string;
  content: string;
  audio: string;
  options: {
    praise: 0 | 1;
    standard: 0 | 1;
    audio: 0 | 1;
  };
}

export const initAgentInfo: IAgentInfo = {
  introduce: '',
  model_name: '',
  img_list: [],
  prompt: '',
  id: 0,
  name: '',
  template_id: 0,
  isFromTem: false,
};
export const initRuanwenInfo: IActiveRuanwen = {
  id: 0,
  title: '',
  subtitle: '',
  content: '',
  audio: '',
  options: {
    praise: 1,
    standard: 1,
    audio: 1,
  },
};

export interface IGrounpChildItem {
  icon: string;
  id: number;
  label: string;
  name: string;
  type: string;
  bind_id: string;
  bind_name: string;
}

interface IConfigItem {
  name: string;
  groups: IConfigGrounpItem[];
}

export const initContentCreate: IContentCreate = {
  unitid: '',
  bookList: [],
  bookData: initBookInfoData,
  config_list: [],
  activeGrounp: null,
  activeGrounpChild: null,
  activeAgentInfo: initAgentInfo,
  activeRuanWenInfo: initRuanwenInfo,
  templateGroups: [],
  activeWenbenchenlieList: [],
  activeKey: 'AI作文辅导',
  isshowBindDrawer: {
    isshow: false,
    type: '',
  },
  testAgent: initITempAgentDataInfo,
  shuxingChangedFlag: false,
  tagList: [],
  guanliAgentChangeFlag: false,
  freshFeedbackFlag: false,
};

export function getUnitid(item: IChapterInfo): string {
  if (item.children && item.children.length) {
    return getUnitid(item.children[0]);
  }
  return item.is_content_unit ? `${item.id}` : '';
}

interface ITemplateGroupsItem {
  id: number;
  name: string;
  is_publish?: boolean;
  children?: ITemplateGroupsItem[];
}
